import React, { PureComponent, Fragment } from 'react'
import { isFunction } from 'util/functions'
import {
  RadioQuestionStep,
  TextQuestionStep,
  ConfirmQuestionStep,
  NoticeQuestionStep,
} from './Steps'
import calculateNextStep from './calculateNextStep'

export default class CancellationModalView extends PureComponent {
  constructor(props) {
    super(props)
    const { workflow } = props
    if (!workflow) {
      throw new Error('You must provide a workflow for the cancellation modal')
    }
    this.initialState = {
      workflowStack: [],
      currentStepStack: [],
      workflow,
      currentStep: workflow[0],
      responses: [],
      completedSteps: [],
    }
    this.state = this.initialState
  }

  getLastWorkflowAnswer = () => {
    const { currentStep: { answers } = {}, responses } = this.state
    if (responses.length > 0 && answers) {
      const lastResponse = responses[responses.length - 1].answer
      return answers.find(a => a === lastResponse || a.text === lastResponse)
    }
    return null
  }

  getCurrentStepAnswers = () => {
    const { currentStep: { answers } = {} } = this.state
    if (answers) {
      return answers.map(a => (typeof a === 'object' ? a.text : a))
    }
    return null
  }

  resetState() {
    this.setState(this.initialState)
  }

  handleNext = response => {
    const { responses, completedSteps, currentStep } = this.state
    let updatedResponses = responses
    if (response && ['radio', 'text'].includes(currentStep.type)) {
      updatedResponses = [...responses, response]
    }
    this.setState(
      {
        completedSteps: [...completedSteps, currentStep],
        responses: updatedResponses,
      },
      () => {
        this.moveToNextStep(this.handleEvents)
      }
    )
  }

  handleEvents = () => {
    const { onComplete, onNext } = this.props
    const { currentStep: { type } = {}, completedSteps, responses } = this.state
    if (!type && isFunction(onComplete)) {
      onComplete({ responses })
      this.resetState()
    } else if (isFunction(onNext) && completedSteps.length > 0) {
      onNext({
        lastCompletedStep: completedSteps[completedSteps.length - 1],
        responses,
      })
    }
  }

  handleCancel = () => {
    const { onCancel } = this.props
    if (isFunction(onCancel)) onCancel()
    this.resetState()
  }

  moveToNextStep = callback => {
    const {
      currentStep,
      currentStepStack,
      workflow,
      workflowStack,
    } = this.state

    this.setState(
      calculateNextStep(
        currentStep,
        currentStepStack,
        workflow,
        workflowStack,
        this.getLastWorkflowAnswer()
      ),
      () => {
        callback()
      }
    )
  }

  render() {
    const { open } = this.props
    const { currentStep: { question, type } = {} } = this.state
    const answers = this.getCurrentStepAnswers()
    return (
      <Fragment>
        {type === 'radio' && (
          <RadioQuestionStep
            question={question}
            answers={answers}
            onCancel={this.handleCancel}
            onNext={this.handleNext}
            open={open}
          />
        )}
        {type === 'text' && (
          <TextQuestionStep
            question={question}
            onCancel={this.handleCancel}
            onNext={this.handleNext}
            open={open}
          />
        )}
        {type === 'confirm' && (
          <ConfirmQuestionStep
            question={question}
            onCancel={this.handleCancel}
            onNext={this.handleNext}
            open={open}
          />
        )}
        {type === 'notice' && (
          <NoticeQuestionStep
            question={question}
            onCancel={this.handleCancel}
            onNext={this.handleNext}
            open={open}
          />
        )}
      </Fragment>
    )
  }
}
